<template>
	<button
		class="tab-button"
		:class="{
			gradient: active
		}"
	>
		<slot>{{ label }}</slot>
	</button>
</template>

<script setup>
defineProps({
	label: String,
	active: {
		type: Boolean,
		default: false
	}
});
</script>

<style scoped>
.tab-button {
	@apply rounded-full px-3 py-1 lg:px-6 lg:py-2 text-sm font-semibold transition-all duration-150 focus:outline-none bg-slate-100 text-slate-600 border border-slate-200;
	white-space: nowrap;
}

.tab-button:hover {
	@apply bg-slate-200;
}

.tab-button.gradient {
	@apply border-yellow-500 bg-yellow-500;
	color: #090d18;
}
</style>
